export const earlyCheckInLegend = 'admin.reservations.check_in.new_early_check_in_legend'
export const tripInsuranceCoverageAlertText = 'reservations.revisions.trip_insurance_coverage_alert'
